import TeamMembersList from './TeamMembersList';
import BreadcrumbWrapper from '../BreadcrumbWrapper';

const TeamMembers = () => {
  return (
    <div>
      <div className="flex">
        <BreadcrumbWrapper
          crumbArray={[{ path: '/team-members', label: 'Team Members' }]}
        />
      </div>

      <h1 className="pt-4 text-2xl font-bold">Team Members</h1>

      <TeamMembersList />
    </div>
  );
};

export default TeamMembers;
